/**
 * 标签切换缓存组件处理混入文件
 */
export default {
    data(){
        return{
            isRefreshComponent:true,
            lock:0
        }
    },
    mounted(){
        this.lock++;
    },
    activated(){
        if (this.lock>0){
            this.lock = 0;
            return;
        }
        if ((!this.$route.query.isKeepAlive || this.$route.query.isKeepAlive == 'undefined')){
            this.refreshKeepalive();
            this.$nextTick(()=>{
                this.handleIsRefreshComponent();
            })
        }
    },
    deactivated() {
        this.lock = 0;
        //切换标签2秒后全局清除提示
        // if (this.$Message){
        //     setTimeout(()=>{
        //         this.$Message.destroy()
        //     },2000)
        // }
    },
    destroyed() {
        this.lock = 0;
    },
    methods: {
        handleIsRefreshComponent(){
            this.isRefreshComponent = false;
            this.$nextTick(()=>{
                this.isRefreshComponent = true;
            })
        }
    }
}